import { useCallback } from 'react';

import { NativeCommunicationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { useFeedbackStore } from '@store';

import { Modals } from '../../modals';

export interface ModalHook {
	hide: (action?: string) => void;
	show: (action?: string) => void;
}

export const useModal = (modalName: Modals): ModalHook => {
	const hideModal = useFeedbackStore((state) => state.hideModal);
	const showModal = useFeedbackStore((state) => state.showModal);

	const show = useCallback(
		(action?: string) => {
			NativeCommunicationHelper.hideButtonContact();
			showModal(modalName, action);
		},
		[modalName, showModal]
	);

	const hide = useCallback(
		(action?: string) => {
			NativeCommunicationHelper.showButtonContact();
			hideModal(modalName, action);
		},
		[modalName, hideModal]
	);

	return {
		hide,
		show,
	};
};

export const useIsVisibleModal = (modalName: Modals) => {
	const visibleModals = useFeedbackStore((state) => state.visibleModals);

	return (visibleModals?.[modalName] || 0) > 0;
};

export const useActionModal = (modalName: Modals) => {
	const visibleModals = useFeedbackStore((state) => state.visibleModals);
	return visibleModals?.['action'] || '';
};
